import { createMachine, createActor, assign } from 'xstate';
import { useLoggerStore } from '@/stores/LoggerStore';
import { useToastSystem } from '@/composables/useToastSystem';

export const callsignMachine = createMachine({
  id: 'callsignEntry',
  initial: 'idle',
  context: {
    callsign: '',
  },
  states: {
    idle: {
      on: {
        ENTER_CALLSIGN: {
          // More idiomatic to separate the assignment from the transition
          actions: 'assignCallsign',
          target: 'processing'
        }
      }
    },
    processing: {
      // Using always for immediate transitions is idiomatic
      always: [
        {
          guard: 'isCallsignEmpty',
          actions: 'clearLookupFields',
          target: 'idle'
        },
        {
          guard: 'canCheckDuplicate',
          actions: 'checkDuplicate',
          target: 'idle'
        },
        {
          target: 'idle'
        }
      ]
    }
  }
}, {
  actions: {
    assignCallsign: assign({
      callsign: (context) => {
        const { event } = context;
        if (event.type === 'ENTER_CALLSIGN') {
          return event?.callsign;
        }
        return '';
      }
    }),
    clearLookupFields: () => {
      const loggerStore = useLoggerStore();
      loggerStore.clearLastLookup();
      loggerStore.clearCurrentQsoLookupFields();
    },
    checkDuplicate: () => {
      const loggerStore = useLoggerStore();
      const { duplicateQsoToast } = useToastSystem();
      const qsos = loggerStore.qsoList.filter(qso =>
        loggerStore.logger?.dupeChecker(loggerStore.currentQso, qso)
      );
      if (qsos.length > 0) {
        duplicateQsoToast(loggerStore.currentQso, qsos[0]);
      }
    }
  },
  guards: {
    isCallsignEmpty: ({ context }) => {
      return context.callsign.length === 0;
    },
    canCheckDuplicate: ({ context }) => {
      const loggerStore = useLoggerStore();
      return Boolean(
        context.callsign &&
        context.callsign.length >= 3 &&
        loggerStore.logger &&
        loggerStore.qsoList.length > 0 &&
        loggerStore.logger.dupeCheckFields.length > 0
      );
    }
  }
});

export function startCallsignStateMachine() {
  return createActor(callsignMachine).start();
}